import dayjs from 'dayjs';
import { FilterData, FacetType, SortByRadio } from '../../../../lib/utils/search/searchModel';
import { Api } from '../../../../lib/types/apiSpec';

const byCompletedDate = (dir: number) => (achiev1: Api.AchievementBase, achiev2: Api.AchievementBase) => {
  if (!achiev1.achievementDate) {
    return 1;
  }
  if (!achiev2.achievementDate) {
    return -1;
  }

  return dir * (dayjs(achiev1.achievementDate).toDate().getTime() - dayjs(achiev2.achievementDate).toDate().getTime());
};

const byName = (dir: number) => (achiev1: Api.AchievementBase, achiev2: Api.AchievementBase) =>
  dir * achiev1.title.localeCompare(achiev2.title);

export const sortBy = (filters: FilterData<FacetType>) => (data: Api.AchievementBase[]) => {
  if (!filters || !data) {
    return [];
  }
  const sorted = [...data];
  const sort = filters.sortBy ?? SortByRadio.name;
  const direction = filters.sortDirection === Api.SortDirection.desc ? -1 : 1;

  if (sort === SortByRadio.dateCompleted) {
    return sorted.sort(byCompletedDate(direction));
  }
  if (sort === SortByRadio.name) {
    return sorted.sort(byName(direction));
  }

  return sorted;
};
